const firebaseConfig = {
    apiKey: "AIzaSyCFgXdiuj5NvgS9AVVuc9GMHiW8XnkWujY",
    authDomain: "machikane-coffee.firebaseapp.com",
    projectId: "machikane-coffee",
    storageBucket: "machikane-coffee.appspot.com",
    messagingSenderId: "838446105130",
    appId: "1:838446105130:web:681b58b1ce980aaa83b953",
    measurementId: "G-DP4B9FYBBR",
};

export default firebaseConfig;